import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import moment from 'moment/min/moment-with-locales';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { confirmAlert } from 'react-confirm-alert';

//components
import withRemoveDialog from '~/hoc/withRemoveDialog';
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import GenericList from '~/components/GenericList/GenericList';
import GenericFilter from '../../../components/GenericList/GenericFilter.js';
import VacationsTotals from './VacationsTotals';
import UserProfileLogo from '../../../components/UserProfileLogo/index.js';
import AbsenceVacationMassTimelogApproval from '../../../components/GenericModal/AbsenceVacationMassTimelogApproval.js';
import UserPromptModal from '../../../components/GenericModal/userPromptModal/index.js';
import RegisterHoldProjectModal from './HoldProject/RegisterHoldProjectModal';
import HoldProjectRegisterModal from './HoldProject/HoldProjectRegisterModal';

//elements
import Button from '../../../components/CustomButton/CustomButton.jsx';

//utils
import { statusMap } from '~/utils/normalStatuses';
import { serverTimeFormat } from '~/library/core';
import { shortDateFormat } from '~/utils/dateFormat';
import { absence_and_vacation_statuses } from '~/utils/normalStatuses';
import customerFeature from '~/utils/customerFeature';
import { getIntegrationIconWithStatus } from '~/utils/integrationUtils';
import { payrollIntegrationOptions } from '../../../utils/constants.js';

//assets
import Edit from '../../../assets/img/editing.svg';
import Delete from '../../../assets/img/deleting.svg';
import cancelIcon from '../../../assets/img/InactiveUser.svg';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';
import ImportFromExcelModal from '../../../components/GenericModal/ImportFromExcelModal';

class VacationsList extends Component {
    constructor(props) {
        super(props);
        const { page, isEdit, lastInteractedId } = this.props.router.location.state || {};
        if (lastInteractedId) {
            this.props.vacationStore.setLastInteractedId(lastInteractedId);
        }
        this.currentIntegrationProduct = props.commonStore?.config?.integration_details?.product || null;
        this.state = {
            accepting: null,
            acceptanceChanged: false,
            selected: null,
            page: page ? page : 0,
            isPageAddedOrEdited: isEdit ? isEdit : false,
            vacationTotalKey: new Date(),
            userPromptModal: {
                source: '',
                header: '',
                showModal: false,
                sourceInfo: {},
                actionMethods: {}
            },
            showHoldProjectModal: false,
            showHoldRegisterModal: false,
        };
        this.handlePageChange = this.handlePageChange.bind(this);
    }

    componentDidMount() {
        if (this.props?.router?.location?.state?.filters) {
            const { filters } = this.props.router.location.state;
            Object.keys(filters).forEach(key => {
                this.props.vacationStore.setFilter(key, filters[key]);
            });
            this.props.vacationStore.onFilter();
        }
    }

    handleTableButtonAction = (id, type, vacation_type = '', full = null) => {
        this.props.vacationStore.setLastInteractedId(id);
        if (type === 'edit') {
            this.props.router.navigate(`/admin/vacations/${id}`,
                { state: { vacation: id, page: this.state.page, isEdit: this.state.isPageAddedOrEdited, lastInteractedId: id } });
        }
        else if (type === 'cancel') {
            this.confirmVacationCancellation(id);
        }
        else if (type === 'remove') {
            if (full?.data?.type === 'hold-project' && full?.data?.meta_data_id) {
                return this.confirmHoldProjectVacationRevert(full.data.meta_data_id, full.user_id);
            }
            this.handlePageChange(this.state.page, true);
            if (vacation_type === 'carry') {
                this.confirmVacationCarryDelete(id);
            } else {
                return this.props.handleDelete(id, (id) => this.removeVacationWithAutoTimesheetCheck(id));
            }
        }
    };

    confirmHoldProjectVacationRevert = (metaDataId, userId) => {
        const { t, commonStore, vacationStore } = this.props;
        confirmAlert({
            title: t('Confirm'),
            message: (
                <div style={{ fontFamily: '"Exo 2", sans-serif' }}>
                    <p>{t('This vacation belongs to a Paused / Hold Project. Deleting it means reverting that hold for this employee - their assignment will be moved back to its original schedule.')}</p>
                    <b className='text-danger'>{t('Changes will be lost that are made after the stagger.')}</b>
                </div>
            ),
            buttons: [
                {
                    label: t('Revert & Delete'), onClick: () => {
                        return vacationStore.revertHoldProject(metaDataId, [userId]).then(res => {
                            if (res.already_reverted) {
                                return commonStore.addNotification(t('This hold has already been reverted'), null, 'warning');
                            }
                            let message = `${t('Project hold reverted')}. ${res.reverted_user_ids.length} ${t('affected assignment(s) restored to their original schedule')}.`;
                            if (res.blocked.length) {
                                message += ` ${res.blocked.length} ${t('could not be reverted because a later hold has since changed their roster')}.`;
                            }
                            commonStore.addNotification(message, null, res.blocked.length ? 'warning' : 'success');
                            vacationStore.resetLastListLoadTime(new Date());
                        }).catch(err => {
                            commonStore.addNotification(err?.response?.body?.error || t('Something went wrong'), null, 'error');
                        });
                    }
                },
                { label: t('Cancel'), onClick: () => { } },
            ],
        });
    };

    handleAutoTimesheetPromptOnLeaveRemoval = (prompt, retryWithDecision) => {
        this.setState({
            userPromptModal: {
                ...prompt,
                actionMethods: {
                    handleCloseUserPromptModal: this.handleCloseUserPromptModal,
                    handleAllowAutoTimesheet: () => {
                        this.handleCloseUserPromptModal();
                        return retryWithDecision({ autoRecordTimesheet: true });
                    },
                    handleDisableAutoTimesheet: () => {
                        this.handleCloseUserPromptModal();
                        return retryWithDecision({ autoRecordTimesheet: false });
                    }
                }
            }
        });
    };

    removeVacationWithAutoTimesheetCheck = (id, decisionData) => {
        return this.props.vacationStore.remove(id, decisionData).then((res) => {
            const autoTimesheetPrompt = res?.userPrompts?.find(p => p.source === 'autoTimesheetOnLeaveRemoval');
            if (autoTimesheetPrompt?.showModal) {
                return this.handleAutoTimesheetPromptOnLeaveRemoval(autoTimesheetPrompt, (decision) => this.removeVacationWithAutoTimesheetCheck(id, decision));
            }
            this.props.vacationStore.resetLastListLoadTime(new Date());
            return res;
        });
    };

    componentWillUnmount() {
        this.props.vacationStore.resetLastListLoadTime(null);
        this.props.vacationStore.clearLastInteractedId();
    }

    renderTableActionButtons = (id, full) => {
        const { commonStore, userStore, t } = this.props;
        const { config } = commonStore;
        const { user_type, id: user_id } = userStore.currentUser;
        const { status, vacation_type } = full;
        const showStatus = (user_type === 'pm' || user_type === 'admin') && customerFeature('allow_accepting');
        const allow = (user_type === 'pm' || user_type === 'admin') && customerFeature('pm_allow_editing_all');
        const isSelfAbsence = full.user_id === user_id;
        const showCommentModal = user_type === 'member' && (full.status === 'approved' || full.status === 'rejected')
        let statusText = status;
        if (!statusText) statusText = 'active';
        statusText = statusMap[statusText] || '';
        return (
            <div className="actions-center">
                {
                    config?.integration_details?.product && full.status === 'approved' && (!full.int_id) && user_type !== 'member' && this.currentIntegrationProduct !== payrollIntegrationOptions.TRIPLETEX && (<OverlayTrigger
                        placement="top"
                        key="payroll_history"
                        overlay={
                            <Tooltip>{`${t("View")} ${t("Payroll")} ${t("History")}`}</Tooltip>
                        }
                    >
                        <button
                            type="button"
                            className="p-0 ml-2 bg-transparent border-0"
                            title={`${t("View")} ${t("Payroll")} ${t("History")}`}
                            onClick={() => (showStatus ? this.handleAccept(id, full) : null)}
                        >
                            <i className="fa fa-history" style={{ color: '#888', fontSize: '1.5em' }} />
                        </button>
                    </OverlayTrigger>)
                }
                {getIntegrationIconWithStatus(config, full, t, false)}
                {customerFeature('allow_accepting') && (
                    <div
                        className={`status-block status-${status || 'active'}${user_type === 'member' ? ' status-no-click-for-member' : ''
                            }`}
                        onClick={() => (showCommentModal ? this.showApproveRejectCommentModal(full) : showStatus ? this.handleAccept(id, full) : null)}
                    >
                        {status === 'active' || !(full.status_changed_by && full.status_changed_on) ? (
                            <div className="text-capitalize">{t(statusText)}</div>
                        ) : (
                            <>
                                <div className="text-capitalize">
                                    {full.status_changed_by &&
                                        moment(new Date(full.status_changed_on)).format(serverTimeFormat(true))}
                                </div>
                                <div className="text-capitalize">
                                    {commonStore.getUsername(full.status_changed_by)}
                                </div>
                            </>
                        )}
                    </div>
                )}
                <OverlayTrigger
                    key="vaction_edit"
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {full?.data?.type === 'hold-project' && full?.data?.meta_data_id ? t("Cannot edit hold project") : t("Edit Vacation")}
                        </Tooltip>
                    }
                >
                    <Button icon_sm fill
                        disabled={status !== 'active' || full?.data?.type === 'hold-project' && full?.data?.meta_data_id}
                        onClick={() => this.handleTableButtonAction(id, 'edit')}>
                        <img src={Edit} alt={"edit button"} />
                    </Button>
                </OverlayTrigger>

                {user_type !== 'admin' &&
                    <OverlayTrigger
                        key="vacation_cancel"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {full?.data?.type === 'hold-project' && full?.data?.meta_data_id ? t("Cannot delete hold project") : t('Cancel Absence')}
                            </Tooltip>
                        }
                    >
                        <Button icon_sm fill
                            disabled={!isSelfAbsence || status !== 'active' || full?.data?.type === 'hold-project' && full?.data?.meta_data_id}
                            onClick={() => this.handleTableButtonAction(id, 'cancel')}>
                            <img src={cancelIcon} alt={'cancel absence'} />
                        </Button>
                    </OverlayTrigger>
                }

                {allow &&
                    <OverlayTrigger
                        key="vaction_delete"
                        placement="top"
                        overlay={
                            <Tooltip id="tooltip-top">
                                {t('Remove Vacation')}
                            </Tooltip>
                        }
                    >
                        <Button icon_sm_delete fill
                            disabled={vacation_type !== 'carry' && status === 'approved' && (!full.is_imported || user_type !== 'admin')}
                            onClick={() => this.handleTableButtonAction(id, 'remove', vacation_type, full)}>
                            <img src={Delete} alt="delete button" />
                        </Button>
                    </OverlayTrigger>
                }
            </div>
        );
    };

    confirmVacationCarryDelete = (id) => {
        return confirmAlert({
            title: this.props.t("Delete Carry Forwarded Vacation"),
            message: `${this.props.t("Are you sure you want to delete this carried-forward vacation? This action cannot be undone.")}`,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => {
                        return this.props.vacationStore.deleteCarryForwardVacation(id).then(res => {
                            this.props.vacationStore.resetLastListLoadTime(new Date());
                            this.props.commonStore.addNotification(this.props.t(res.message), null, 'success')
                        }).catch(err => {
                            console.error(err)
                        })
                    },
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        });
    }

    confirmVacationCancellation = (id) => {
        return confirmAlert({
            title: this.props.t("Vacation Cancellation"),
            message: `${this.props.t("Are you sure you want to cancel this request, it cannot be changed later")}?`,
            buttons: [
                {
                    label: this.props.t('Yes'),
                    onClick: () => this.cancelVacationWithAutoTimesheetCheck(id),
                },
                {
                    label: this.props.t('No'),
                    onClick: () => { },
                },
            ],
        });
    }

    cancelVacationWithAutoTimesheetCheck = (id, decisionData) => {
        return this.props.vacationStore.cancelVacation(id, decisionData).then((res) => {
            const autoTimesheetPrompt = res?.userPrompts?.find(p => p.source === 'autoTimesheetOnLeaveRemoval');
            if (autoTimesheetPrompt?.showModal) {
                return this.handleAutoTimesheetPromptOnLeaveRemoval(autoTimesheetPrompt, (decision) => this.cancelVacationWithAutoTimesheetCheck(id, decision));
            }
            this.props.vacationStore.resetLastListLoadTime(new Date());
            this.setState({ vacationTotalKey: new Date() });
            this.props.commonStore.addNotification(this.props.t(res.message), null, 'success')
        }).catch((err) => {
            this.props.commonStore.addNotification(this.props.t(err), null, 'error');
        })
    }

    handleAccept(id, full) {
        this.props.vacationStore.setLastInteractedId(id);
        this.setState({
            accepting: {
                ids: [id],
                count: 1,
                entity: 'vacation',
            },
        });
    }

    onMassAccept() {
        const ids = [];
        if (!this.state.selected) return;
        Object.keys(this.state.selected).forEach((id) => {
            if (this.state.selected[id]) ids.push(id);
        });
        this.setState({
            acceptanceChanged: false,
            accepting: {
                ids,
                count: ids.length,
                entity: 'vacation',
            },
        });
    }

    afterMassAccept() {
        this.handlePageChange(this.state.page, true);
        this.props.vacationStore.resetLastListLoadTime(new Date());
        this.setState({ accepting: null, acceptanceChanged: true });
    }

    handleCloseUserPromptModal = () => {
        this.setState({ userPromptModal: { ...this.state.userPromptModal, showModal: false } })
    }

    showApproveRejectCommentModal = (full) => {
        const { commonStore } = this.props;
        const dateTimeRules = commonStore.getDateTimeRules();
        this.setState({
            userPromptModal: {
                source: 'adminPmComment',
                header: 'Comment',
                showModal: true,
                sourceInfo: {
                    status: full.status,
                    status_note: full.status_note,
                    status_changed_by: commonStore.getUsername(full.status_changed_by),
                    status_changed_on: shortDateFormat(full.status_changed_on, dateTimeRules)
                },
                actionMethods: { handleCloseUserPromptModal: this.handleCloseUserPromptModal }
            }
        });
    }

    //handles generic list page change//
    handlePageChange = (page, isEdit) => {
        this.setState({ page, isPageAddedOrEdited: isEdit });
    };

    // Staggered Schedule / Hold Project handlers
    handleRegisterHoldProject = () => {
        this.setState({ showHoldProjectModal: false });
    }

    getRowClassName = (row) => {
        const isInteracted = row.id === this.props.vacationStore.lastInteractedId;
        const baseClass = row.vacation_type === 'carry' ? 'carry-forward-bg-color' : '';
        return isInteracted ? `${baseClass} interacted-row`.trim() : baseClass;
    }

    handleOnHideModal = (modalKey) => {
        this.setState({ [modalKey]: false });
        this.props.vacationStore.resetLastListLoadTime(new Date());
    }

    render() {
        const { loading, filters, appliedFilters, lastInteractedId } = this.props.vacationStore;
        const { user_type, id } = this.props.userStore.currentUser;
        const { accepting, page, isPageAddedOrEdited, vacationTotalKey, userPromptModal,
            showHoldProjectModal, showHoldRegisterModal } = this.state;
        const { config } = this.props.commonStore;
        const { dateTimeRules = false, basicRules, Vacation_setup = null } = config.client && config.client.data ? config.client.data : {};
        const allowImportFromExcel = basicRules?.allowImportFromExcel;
        const { replace_label = 'Hold Project', allow_staggered_vacation = false } = Vacation_setup?.vacationOtherSettings || {};

        return (
            <Fragment>
                <Modal size="lg" show={!!accepting} onHide={() => this.setState({ accepting: null })}>
                    <Modal.Header>
                        <Modal.Title className="w-100 text-center m-0">{this.props.t('Accept/reject')}</Modal.Title>
                        <img
                            src={CloseModalIcon}
                            alt='closeIcon'
                            className="cursor-pointer"
                            onClick={() => this.setState({ accepting: null })}
                        />
                    </Modal.Header>

                    <Modal.Body>
                        <AbsenceVacationMassTimelogApproval params={accepting} afterSave={() => this.afterMassAccept()} />
                    </Modal.Body>
                </Modal>
                {(user_type === 'member' || user_type === 'pm') && <VacationsTotals key={vacationTotalKey} user={id} />}
                <div className="table-list">
                    <div className="table-list__header"></div>
                    <GenericList
                        columns={[
                            user_type === 'member'
                                ? null
                                : {
                                    Header: '',
                                    id: 'user_image',
                                    accessor: ({ user_image }) => (
                                        <UserProfileLogo image_id={user_image ? user_image : false} />
                                    ),
                                    maxWidth: 60,
                                },
                            user_type === 'member'
                                ? null
                                : {
                                    Header: 'Member',
                                    id: 'first_name',
                                    isSortable: true,
                                    accessor: ({ first_name, last_name }) => (
                                        <span>{first_name + ' ' + last_name}</span>
                                    ),
                                    textAlign: 'start',
                                },
                            {
                                Header: 'Project',
                                id: 'project_name',
                                isSortable: true,
                                accessor: ({ project_number, project_name }) => <span>
                                    {project_name ? ((project_number ? `${project_number} | ` : '') + project_name) : "-"}
                                </span>,
                                textAlign: 'start',
                            },
                            {
                                Header: 'type',
                                id: 'vacation_type',
                                accessor: ({ vacation_type, is_imported, data }) => (
                                    vacation_type === 'carry' ? <span>{this.props.t('Carry Forwarded')}</span>
                                        : is_imported ? <span className="text-capitalize">{this.props.t('Imported')}</span>
                                            : data?.type === 'hold-project' ? <span className="text-capitalize">{vacation_type} ({replace_label})</span>
                                                : <span className="text-capitalize">{vacation_type}</span>
                                ),
                                textAlign: 'start',
                            },
                            {
                                Header: 'From date',
                                id: 'from',
                                isSortable: true,
                                maxWidth: 90,
                                accessor: ({ from }) => <span>{shortDateFormat(from, dateTimeRules)}</span>,
                            },
                            {
                                Header: 'To date',
                                id: 'to',
                                isSortable: true,
                                maxWidth: 90,
                                accessor: ({ to }) => <span>{shortDateFormat(to, dateTimeRules)}</span>,
                            },
                            {
                                Header: 'Total days',
                                id: 'total_days',
                                maxWidth: 90,
                                accessor: ({ total_days, vacation_type }) => (
                                    vacation_type === 'carry' ? <span>+{total_days}</span> : <span>{total_days}</span>
                                ),
                            },
                            {
                                Header: 'Actions',
                                id: 'actions',
                                sortable: false,
                                maxWidth: 150,
                                minWidth: 100,
                                accessor: (full) => this.renderTableActionButtons(full.id, full),
                            },
                        ]}
                        header={
                            <GenericFilter
                                filters={filters}
                                setFilter={(name, value) => this.props.vacationStore.setFilter(name, value)}
                                onFilter={() => this.props.vacationStore.onFilter()}
                                loading={loading}
                                hasSearch={user_type !== 'member'}
                                searchFilterPlaceholder={"Search by employee name"}
                                hasDateFilters={true}
                                hasStatusFilter={true}
                                statusOptions={absence_and_vacation_statuses}
                            />
                        }
                        getRowClassName={this.getRowClassName}
                        onRowClick={(row) => {
                            const current = this.props.vacationStore.lastInteractedId;
                            this.props.vacationStore.setLastInteractedId(current === row.id ? null : row.id);
                        }}
                        tableHeader={this.props.t('Vacations')}
                        filters={appliedFilters}
                        cutomCheckBoxClass={"top-position"}
                        lastListLoadTime={this.props.vacationStore.lastListLoadTime}
                        requestData={(params) => this.props.vacationStore.loadList(params)}
                        handlePageChange={(page, isEdit) => this.handlePageChange(page, isEdit)}
                        page={page}
                        isPageAddedOrEdited={isPageAddedOrEdited}
                    >
                        {!!allow_staggered_vacation &&
                            <>
                                {(user_type === 'admin' || user_type === 'pm') && (
                                <span
                                    role="button"
                                    className="fs12 fw-600 cursor-pointer text-primary-color me-3 d-flex align-items-center"
                                    onClick={() => this.setState({ showHoldRegisterModal: true })}
                                >
                                    <i className="fa fa-history me-1" />
                                    {this.props.t('View')} {this.props.t(replace_label) || 'Paused / Hold Project'}
                                </span>
                                )}
                                {(user_type === 'admin' || user_type === 'pm') && (
                                <Button fill wd className="me-3" onClick={() => this.setState({ showHoldProjectModal: true })}>
                                    <i className="fa fa-pause-circle fa-xl margin-right-10" />
                                    {this.props.t(replace_label) || 'Register Paused / Hold Project'}
                                </Button>
                                )}
                            </>
                        }
                        {(user_type === 'admin') && allowImportFromExcel && <ImportFromExcelModal
                            importEntityType={'usedVacationDays'}
                            entityName={this.props.t('Used Vacation Days')}
                            sampleFileName={'used_vacation_days_import_sample_file.xlsx'}
                        />}
                        <Button fill wd onClick={() => this.props.router.navigate('/admin/reports/vacation')}>
                            <i className="fa fa-table fa-xl margin-right-10" />
                            {this.props.t('Download Excel File')}
                        </Button>
                        <Button fill wd onClick={() => this.props.onAdd(page, isPageAddedOrEdited)}>
                            <i className="fa fa-plus-circle fa-xl margin-right-10" />
                            {this.props.t('Add new')}
                        </Button>
                    </GenericList>
                </div>

                <UserPromptModal
                    source={userPromptModal.source}
                    header={userPromptModal.header}
                    showModal={userPromptModal.showModal}
                    sourceInfo={userPromptModal.sourceInfo}
                    actionMethods={userPromptModal.actionMethods}
                />
                <RegisterHoldProjectModal
                    show={showHoldProjectModal}
                    onHide={() => this.handleOnHideModal('showHoldProjectModal')}
                    onRegister={this.handleRegisterHoldProject}
                    dateFormat={dateTimeRules?.short_date_format}
                />
                <HoldProjectRegisterModal
                    show={showHoldRegisterModal}
                    onHide={() => this.handleOnHideModal('showHoldRegisterModal')}
                    dateFormat={dateTimeRules?.short_date_format}
                />
            </Fragment>
        );
    }
}

export default inject(
    'vacationStore',
    'userStore',
    'timelogStore',
    'commonStore'
)(applicationRouter(withLocalization(withRemoveDialog(observer(VacationsList)))));
